import React from 'react';
import { DndProvider } from 'react-dnd';
import CustomBackend from './helpers/custom-backend';

const DragAndDropProvider = ({ children }) => (
  <DndProvider backend={CustomBackend}>{children}</DndProvider>
);
export default DragAndDropProvider;
